import ScheduleMain from "@/views/admin/schedule/ScheduleMain";

export default {
  path: "schedule/main",
  name: "scheduleMain",
  component: ScheduleMain,
  meta: {
    requiresAuth: true
  }
};
